import { forwardRef } from "react";
import { classNames } from "zeta-dom-react";
import { IconNames, IconText } from "../common";

export interface LinkButtonProps extends Omit<React.ComponentPropsWithRef<'a'>, 'children'> {
    label: string;
    icon?: IconNames;
    variant?: 'primary' | 'outlined' | 'link';
    disabled?: boolean;
}

export const LinkButton = forwardRef<HTMLAnchorElement, LinkButtonProps>((props, ref) => {
    const { label, icon, variant, disabled, ..._props } = props;
    return (
        <a {..._props} ref={ref} className={classNames(props.className, 'eac-button', { disabled: !!disabled, variant: variant || 'outlined' })}>
            {icon ? <IconText icon={icon}>{label}</IconText> : label}
        </a>
    );
});
